import { Actions } from './map.actions';
import { fromJS } from 'immutable';
import * as industriesTypes from './map.types'



export const initialState = fromJS(
    {
        streetGeoJson: {
            isLoading: false,
            data: {}
        },
    }
)


export function mapReducer(state = initialState, action: Actions) {

    switch (action.type) {


        case industriesTypes.FETCH_STREET_GEO_JSON_REQUEST: {
            return state
                .setIn(['streetGeoJson', 'isLoading'], true)
        }

        case industriesTypes.FETCH_STREET_GEO_JSON_SUCCESS: {
            return state
                .setIn(['streetGeoJson', 'isLoading'], false)
                .setIn(['streetGeoJson', 'data'], fromJS(action.payload))
        }


        case industriesTypes.FETCH_STREET_GEO_JSON_FAILURE: {
            return state
                .setIn(['streetGeoJson', 'isLoading'], false)
        }

        case industriesTypes.UPDATE_FIELD:
            let fields = [];

            if (action.path === '') {
                fields = action.field.split('.');
            } else {
                fields = action.path
                    .split('.')
                    .concat(action.field.split('.'));
            }
            const value = action.value;

            if (fields.length === 1) {
                return state.set(fields[0], fromJS(value));
            }
            return state.setIn(fields, fromJS(value));
        case industriesTypes.SET_DEFAULT_DATA:
            const path = action.path || '';
            return state.setIn(
                path.split('.'),
                initialState.getIn(path.split('.'))
            );

        default: return state;
    }
}